/* eslint-disable import/no-unresolved */

import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import ImageDesktopWebp from './images/account-protection-hero-desktop.webp';
import ImageMobileWebp from './images/account-protection-hero-mobile.webp';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='investment-account-protection-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Investment Account Protection'
      headingText={<>How Northwestern Mutual protects <WidowBlock>your investments</WidowBlock></>}
      descriptionText={''} // required field
      backgroundImageAriaLabel='A business women looking off into the distance in the city'
      backgroundImageDesktop={ImageDesktopWebp.toString()}
      backgroundImageMobile={ImageMobileWebp.toString()}
      backgroundImageDesktopLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundImageMobileLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
